import useAuth from '../auth/useAuth';

export default function usePermission() {
  const { permissions, meLoading } = useAuth();

  const safePermissions = Array.isArray(permissions) ? permissions : [];
  const has = (perm) => safePermissions.includes(perm);

  return { has, permissions, meLoading };
}
